<template>
  <el-dialog
    class="teacher-dialog"
    title="编辑考试安排"
    :visible.sync="dialogVisible"
    width="50%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    @close="handleClose">
    <!-- 表单 -->
    <div class="form-container">
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="考试安排" prop="examTitle">
          <el-input
            v-model="form.examTitle"
            placeholder="请输入考试安排"
            maxLength="50">
          </el-input>
        </el-form-item>
        <el-form-item label="考试安排内容" prop="examContent">
          <!-- <el-input
            v-model="form.examContent"
            placeholder="请输入考试安排内容"
            maxLength="50">
          </el-input> -->
          <QuillEditor3 v-model="form.examContent" placeholder="请输入考试安排内容" :maxlength="50" />
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="onSubmit('ruleForm', false)">确 认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import QuillEditor3 from '@/components/QuillEditor/index3'
export default {
  components: {
    QuillEditor3
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isEdit: false,
      form: {
        examTitle: '',
        examContent: ''
      },
      rules :{
        examTitle: [
          { required: true, message: '考试安排不能为空', trigger: 'blur' },
        ],
        examContent: [
          { required: true, message: '考试安排内容不能为空', trigger: 'blur' },
        ]
      }
    }
  },
  methods: {
    init(data) {
      if (data) {
        this.form = {
          id: data.id,
          examTitle: data.examTitle,
          examContent: data.examContent
        };
        this.isEdit = data.isEdit
        return;
      }
      this.isEdit = false;
      this.form = {
        examTitle: '',
        examContent: ''
      }
    },
    // 关闭弹窗
    handleClose() {
      this.$emit('close');
    },
    // 提交表单/是否预览
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit('submit', {
            form: this.form,
            isEdit: this.isEdit
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>
  .teacher-dialog {
    ::v-deep .el-dialog {
      .el-dialog__header {
        // background-color: #909399;
        padding: 10px;
        .el-dialog__title {
          font-size: 15px;
          // color: #fff;
        }
        .el-dialog__headerbtn {
          top: 10px;
          i {
            // color: #fff;
          }
        }
      }
      .el-dialog__body {
        max-height: 500px;
        overflow-y: scroll;
      }
      .el-form {
        .el-form-item {
          margin-bottom: 25px;
          .el-form-item__error {
            margin: 5px 0;
          }
          .el-form-item__label {
            font-size: 12px;
          }
          .el-input {
            width: 500px;
          }
        }
      }
      .el-dialog__footer {
        width: 100%;
        border-top: 1px solid #ddd;
        padding-top: 15px;
      }
    }
  }
</style>
